const { roles } = require("../../config/ProjectConfig");

const isAdminRole = (role) => role === roles[2];

export default isAdminRole